import {
  DRAW_GAME,
  GET_GAME,
  GIFT_LIST,
  HISTORY,
  INSERT_ADDRESS,
  RETRY_GIFT,
  SHOWING,
  USER_INFO,
} from "@/stores/actions";

import {
  SET_DRAW_GAME,
  SET_GAME,
  SET_GIFT_LIST,
  SET_HISTORY,
  SET_HISTORY_LOCATE,
  SET_INSERT_ADDRESS,
  SET_RETRY_GIFT,
  SET_SHOWING,
  SET_USER_INFO,
} from "@/stores/mutations";

import { GameServiceAPI } from "@/api/game";
import { transformVM } from "@/transforms";

export const actions = {
  async [USER_INFO]({ commit }, params) {
    try {
      let result = await GameServiceAPI.getUserInfo(params);
      if (result && result.status === 200) {
        commit(SET_USER_INFO, transformVM.gameVM.transformUser(result.data));
      }
      return result;
    } catch (e) {
      return e;
    }
  },

  async [GET_GAME]({ commit, getters }, params) {
    try {
      if (
        getters.game &&
        Object.keys(getters.game).length > 0 &&
        (typeof params.is_reload === "undefined" ||
          (typeof params.is_reload !== "undefined" && !params.is_reload))
      ) {
        return true;
      } else {
        let result = await GameServiceAPI.getGame(params);
        if (result && result.status === 200) {
          commit(SET_GAME, transformVM.gameVM.transformGame(result.data));
        }
        return result;
      }
    } catch (e) {
      return e;
    }
  },

  async [GIFT_LIST]({ commit, getters }, params) {
    try {
      if (
        getters.gifts &&
        getters.gifts.length > 0 &&
        (typeof params.is_reload === "undefined" ||
          (typeof params.is_reload !== "undefined" && !params.is_reload))
      ) {
        return true;
      } else {
        let result = await GameServiceAPI.getGifts(params);
        if (result && result.status === 200) {
          commit(
            SET_GIFT_LIST,
            transformVM.gameVM.transformGifts(result.data.rewards)
          );
        }
        return result;
      }
    } catch (e) {
      return e;
    }
  },

  async [HISTORY]({ commit, getters }, params) {
    try {
      if (
        typeof getters.historyByLangPage(params.offset, params.language) !==
          "undefined" &&
        (typeof params.is_reload === "undefined" ||
          (typeof params.is_reload !== "undefined" && !params.is_reload))
      ) {
        commit(SET_HISTORY_LOCATE, params.language);
        return true;
      } else {
        let result = await GameServiceAPI.history(params);
        if (result && result.status === 200) {
          commit(SET_HISTORY, {
            page: params.offset,
            lang: params.language,
            data: transformVM.gameVM.transformHistory(
              result.data.customer_rewards
            ),
          });
        }
        return result;
      }
    } catch (e) {
      console.log(e);
      return e;
    }
  },

  async [DRAW_GAME]({ commit }, params) {
    try {
      let result = await GameServiceAPI.drawGift(params);
      if (result && result.status === 200) {
        commit(SET_DRAW_GAME, transformVM.gameVM.transformDraw(result.data));
      }
      return result;
    } catch (e) {
      return e;
    }
  },

  async [RETRY_GIFT]({ commit }, params) {
    try {
      let result = await GameServiceAPI.retryGift(params);
      if (result && result.status === 200) {
        commit(SET_RETRY_GIFT, result.data);
      }
      return result;
    } catch (e) {
      return e;
    }
  },

  async [INSERT_ADDRESS]({ commit }, params) {
    try {
      let result = await GameServiceAPI.insertAddress(params);
      if (result && result.status === 200) {
        commit(SET_INSERT_ADDRESS, result.data);
      }
      return result;
    } catch (e) {
      return e;
    }
  },

  async [SHOWING]({ commit }) {
    commit(SET_SHOWING, true);
  },
};
